<template>
  <card>
    <radio-list v-model="nav" :items="navs"></radio-list>
    <template v-for="(n, k) in navs">
      <!-- <KeepAlive> -->
      <component v-if="n.id === nav" :is="n.id" :key="k"></component>
      <!-- </KeepAlive> -->
    </template>
  </card>
</template>
<script>
export default {
  components: {
    "variant-list": () => import("@/components/Stock/Variants"),
    "brand-list": () => import("@/components/Stock/Brands"),
    "category-list": () => import("@/components/Stock/Categories"),
    "product-list": () => import("@/components/Stock/Products"),
  },
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      nav: "variant-list",
      navs: [
        {
          title: "Модификации",
          titleKey: "variant-list",
          id: "variant-list",
        },
        {
          title: "Товары",
          titleKey: "product-list",
          id: "product-list",
        },
        {
          title: "Категории",
          titleKey: "category-list",
          id: "category-list",
        },
        {
          title: "Бренды",
          titleKey: "brand-list",
          id: "brand-list",
        },
      ],
    };
  },
};
</script>